import React from 'react';
import {
    formatAuditActorLabel,
    formatAuditDate,
    formatAuditEntityLabel,
    getAuditActionLabel,
    getAuditEntityTypeLabel,
    stringifyAuditSnapshot,
} from '../helpers';

export const AuditLogDetailModal = ({
    isOpen,
    auditLog,
    isLoading,
    error,
    onClose,
}) => {
    React.useEffect(() => {
        if (!isOpen) {
            return undefined;
        }

        const handleEscape = (event) => {
            if (event.key === 'Escape') {
                onClose();
            }
        };

        document.addEventListener('keydown', handleEscape);
        return () => document.removeEventListener('keydown', handleEscape);
    }, [isOpen, onClose]);

    if (!isOpen) {
        return null;
    }

    const changedFields = Array.isArray(auditLog?.metadata?.changedFields) ? auditLog.metadata.changedFields : [];

    return (
        <div className="audit-log-modal-backdrop" onClick={onClose}>
            <div className="audit-log-modal" role="dialog" aria-modal="true" aria-labelledby="audit-log-detail-title" onClick={(event) => event.stopPropagation()}>
                <div className="audit-log-modal__header">
                    <div>
                        <h5 id="audit-log-detail-title" className="mb-1 fw-bold">Detalle de auditoría</h5>
                        <div className="text-muted fs-12">{auditLog?.summary || 'Registro de auditoría'}</div>
                    </div>
                    <button type="button" className="btn btn-sm btn-light" onClick={onClose}>
                        <i className="feather-x" />
                    </button>
                </div>

                <div className="audit-log-modal__body">
                    {isLoading && <div className="text-muted">Cargando detalle...</div>}
                    {!isLoading && error && <div className="alert alert-danger py-2 mb-0">{error}</div>}
                    {!isLoading && !error && auditLog && (
                        <>
                            <div className="audit-log-detail-grid">
                                <div className="audit-log-detail-card">
                                    <span className="audit-log-detail-card__label">Fecha</span>
                                    <strong>{formatAuditDate(auditLog.createdDate)}</strong>
                                </div>
                                <div className="audit-log-detail-card">
                                    <span className="audit-log-detail-card__label">Actor</span>
                                    <strong>{formatAuditActorLabel(auditLog)}</strong>
                                </div>
                                <div className="audit-log-detail-card">
                                    <span className="audit-log-detail-card__label">Acción</span>
                                    <strong>{getAuditActionLabel(auditLog.action)}</strong>
                                </div>
                                <div className="audit-log-detail-card">
                                    <span className="audit-log-detail-card__label">Entidad</span>
                                    <strong>{getAuditEntityTypeLabel(auditLog.entityType)}</strong>
                                    <div className="text-muted fs-12">{formatAuditEntityLabel(auditLog)}</div>
                                </div>
                            </div>

                            {changedFields.length > 0 && (
                                <div className="audit-log-detail-section">
                                    <div className="audit-log-detail-section__title">Campos modificados</div>
                                    <div className="audit-log-chip-list">
                                        {changedFields.map((field) => (
                                            <span key={field} className="audit-log-detail-chip">{field}</span>
                                        ))}
                                    </div>
                                </div>
                            )}

                            <div className="audit-log-detail-section">
                                <div className="audit-log-detail-section__title">Metadata</div>
                                <div className="audit-log-chip-list">
                                    <span className="audit-log-detail-chip">IP: {auditLog?.metadata?.ip || 'N/D'}</span>
                                    <span className="audit-log-detail-chip">Navegador: {auditLog?.metadata?.userAgent || 'N/D'}</span>
                                </div>
                            </div>

                            <div className="audit-log-json-grid">
                                <div className="audit-log-json-card">
                                    <div className="audit-log-detail-section__title">Before</div>
                                    <pre className="audit-log-json-card__body">{stringifyAuditSnapshot(auditLog.before)}</pre>
                                </div>
                                <div className="audit-log-json-card">
                                    <div className="audit-log-detail-section__title">After</div>
                                    <pre className="audit-log-json-card__body">{stringifyAuditSnapshot(auditLog.after)}</pre>
                                </div>
                            </div>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
};